import { motion } from 'motion/react';

const MODES = ['ceo', 'cmo', 'coo', 'cfo', 'cto'];
const MODE_LABELS: Record<string, string> = {
  ceo: 'CEO',
  cmo: 'CMO',
  coo: 'COO',
  cfo: 'CFO',
  cto: 'CTO',
};

interface SpecialistTabsProps {
  currentMode: string;
}

const SpecialistTabs = ({ currentMode }: SpecialistTabsProps) => {
  const currentIndex = MODES.indexOf(currentMode.toLowerCase());

  return (
    <div className="flex items-center gap-1 mb-5 overflow-x-auto no-scrollbar snap-x">
      {MODES.map((mode, index) => {
        const isActive = mode === currentMode.toLowerCase();
        const isPast = index < currentIndex;

        return (
          <div key={mode} className="flex items-center flex-shrink-0 snap-start">
            <motion.div
              animate={isActive ? { scale: 1.05 } : { scale: 1 }}
              className={`relative px-3 py-2 rounded-xl text-xs font-bold transition-colors flex items-center gap-1.5
                ${isActive 
                  ? 'bg-amber-500 text-white shadow-md' 
                  : isPast 
                    ? 'bg-amber-100 dark:bg-amber-900/30 text-amber-700 dark:text-amber-300' 
                    : 'bg-slate-100 dark:bg-slate-800 text-slate-400 dark:text-slate-500'
                }
              `}
            >
              <span className="w-5 h-5 rounded-full bg-white/20 flex items-center justify-center text-[10px]">
                {isPast ? '✓' : index + 1}
              </span>
              {MODE_LABELS[mode]}
            </motion.div>
            {index < MODES.length - 1 && (
              <div className={`w-3 h-px mx-0.5 ${index < currentIndex ? 'bg-amber-300 dark:bg-amber-700' : 'bg-slate-200 dark:bg-slate-700'}`} />
            )}
          </div>
        );
      })}
    </div>
  );
};

export default SpecialistTabs;
